import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { LayoutService } from './service/app.layout.service';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { DropdownModule } from 'primeng/dropdown';
import { FormsModule } from '@angular/forms';
import { AuthService } from '@core/services/auth.service';
import { firstValueFrom } from 'rxjs';
import { EditionService } from '../modules/editions/edition.service';
import { environment } from '../../environments/environment';

@Component({
  selector: 'gt-admin-topbar',
  standalone: true,
  templateUrl: './app.topbar.component.html',
  imports: [CommonModule, RouterModule, DropdownModule, FormsModule],
})
export class AppTopBarComponent implements OnInit {
  items!: MenuItem[];

  @ViewChild('menubutton') menuButton!: ElementRef;

  @ViewChild('topbarmenubutton') topbarMenuButton!: ElementRef;

  @ViewChild('topbarmenu') menu!: ElementRef;

  activeEditions$ = this.editionService.activeEditions$;
  currentEditionId = localStorage.getItem('editionId');

  showSeasons = true;

  version = environment.version;

  constructor(
    public layoutService: LayoutService,
    public authService: AuthService,
    public router: Router,
    private editionService: EditionService,
  ) {}

  ngOnInit(): void {
    if (this.currentEditionId) {
      this.editionService.setEditionId(this.currentEditionId);
    }
  }

  logout() {
    firstValueFrom(this.authService.logout()).then(() => {
      this.router.navigate(['/login']);
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setEdition(event: any) {
    localStorage.setItem('editionId', event.value);
    this.editionService.setEditionId(event.value);
  }
}
